export enum SortOrder {
    DESC = "DESC",
    ASC = "ASC",
}

type ViewFilterProps = {
    keywords?: string[];
    startDate?: Date;
    endDate?: Date;
    identifiedSendersEmails?: string[];
    identifiedRecipientsEmails?: string[];
    sortOrder?: SortOrder;
};

export default class ViewFilter {
    keywords?: string[];

    startDate?: Date;

    endDate?: Date;

    identifiedSendersEmails?: string[];

    identifiedRecipientsEmails?: string[];

    sortOrder?: SortOrder;

    constructor({
        keywords,
        startDate,
        endDate,
        identifiedSendersEmails,
        identifiedRecipientsEmails,
        sortOrder,
    }: ViewFilterProps) {
        this.keywords = keywords;
        this.startDate = startDate;
        this.endDate = endDate;
        this.identifiedSendersEmails = identifiedSendersEmails;
        this.identifiedRecipientsEmails = identifiedRecipientsEmails;
        this.sortOrder = sortOrder;
    }
}
